export class TreeSelectionModel {
    constructor(public value: number, public label: string, public group: string, public isSelected: boolean = true) {
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/tree-selection.model.ts